<!-- <div id="dialogbox">


    <div>
        <header class="d-flex justify-content-between">
            <div class="dialogbox-title nunito mb-0">{{getFormTitle}}</div>
            <div class="row">
                <div class="col-md-12">
                    <div class="list-filters">
                    </div>
                </div>
            </div>
        </header>
        <section>
            <div class="row">
                <div class="col-md-12">
                    <div class="example-container mat-elevation-z8" (scroll)="onTableScroll($event)">
                        <table #compGenericVFTbl mat-table class="mat-elevation-z8 app-vf-table"
                            [dataSource]="this.dataSource" matSort>
                            <ng-container [matColumnDef]="col" *ngFor="let col of this.getDisplayedColumnsNamesList">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-color"
                                    (click)="setupFilterKey(col)">
                                    {{getActualString(col)}}
                                </th>
                                <ng-container *ngIf="col=='Select' && this.getIsCflSingleSelection">
                                    <td mat-cell *matCellDef="let element;">
                                        <mat-radio-button [value]="element" [checked]="element.isSelected"
                                            (change)="onChangeRadio($event)"></mat-radio-button>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="col=='Select' && this.getIsCflSingleSelection==false">
                                    <td mat-cell *matCellDef="let element;">
                                        <mat-checkbox value="element" [checked]="element.isSelected"
                                            (change)="onChangeCheckBox($event,element)" color="primary"></mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container *ngIf="col!='Select'">
                                    <td mat-cell *matCellDef="let element;">
                                        <span style="line-height: 0;">{{element[col]}}</span>
                                    </td>
                                </ng-container>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;">
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div class="bottom-buttons">
        <button [mat-dialog-close]="true" mat-raised-button class="fullwidth warn adminredbtn"
            (click)="onChooseFromCFL()">
            <mat-icon>close</mat-icon>
            Choose
        </button>
        <button [mat-dialog-close]="true" mat-raised-button class="fullwidth warn adminredbtn" (click)="onCloseCFL()">
            <mat-icon>close</mat-icon>
            Cancel
        </button>
    </div>
</div> -->

<div class="generic-cfl">
    <!-- <mat-dialog-actions align="end" class="dialog-actions"> -->
    <!-- <button class="close-button" mat-icon-button [mat-dialog-close]="true" (click)="onCloseCFL()">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button> -->
    <!-- </mat-dialog-actions> -->

    <h2 mat-dialog-title class="dialog-title text-center fs-5">{{getFormTitle}}</h2>

    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-md-12 tabledesign p-0">
                <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChipCFL($event.index,$event.data)">
                </app-chip>
                <div class="example-container cfl-table mat-elevation-z8" (scroll)="onTableScroll($event)">

                    <!-- <div class="example-container cfl-table mat-elevation-z8"   infiniteScroll
     [infiniteScrollDistance]="0"
   
     
     [scrollWindow]="false" (scrolled)="onTableScroll($event)"> -->

                    <table mat-table #compGenericVFTbl [dataSource]="this.dataSource">

                        <ng-container [matColumnDef]="col" *ngFor="let col of this.getDisplayedColumnsNamesList">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-color">
                                {{ getActualString(
                                col == 'documentStatusName' ? 'Status' :
                                col == 'cardName' ? 'BP Name' :
                                col == 'cardCode' ? 'BP Code' :
                                col == 'cardTypeName' ? 'BP Type' :
                                col == 'u_BudgetCategory' ? 'Budget Category' :
                                col == 'genderName' ? 'Gender' :
                                col == 'name' ? (getFormTitle == 'Chart Of Account' || getFormTitle == 'Tax Code' ||
                                getFormTitle == 'Distribution' || getFormTitle ==
                                'Project' ? 'Name' : 'Contact Person ID') :

                                col == 'u_Type' ? 'Type' :
                                col
                                ) }}
                                <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"
                                    *ngIf="getActualString(col)!='Select' && !this.getIsItCflEnumList"
                                    style="cursor:pointer">
                                </i-feather>

                                <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">

                                    <app-filter [colType]="getColType(col)" [shortColumn]="col" [isActive]="this.active"
                                        [labelType]="col"
                                        (FilterColumn)="checkFilterDataType($event.column, $event.formid, $event.toid,$event.label)"
                                        (sortFilter)="this.onClickOfGenericColumnSortCFL(col,this.active)">
                                    </app-filter>

                                </mat-menu>
                            </th>

                            <ng-container *ngIf="col=='Select' && this.getIsCflSingleSelection">
                                <td mat-cell *matCellDef="let element;">
                                    <mat-radio-button [value]="element" [checked]="element.isSelected"
                                        (change)="onChangeRadio($event)"></mat-radio-button>
                                </td>
                            </ng-container>

                            <ng-container *ngIf="col=='Select' && this.getIsCflSingleSelection==false">
                                <td mat-cell *matCellDef="let element;">
                                    <mat-checkbox value="element" [checked]="element.isSelected"
                                        (change)="onChangeCheckBox($event,element)" color="primary"></mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container
                                *ngIf="col!='Select' && col!='docDate' && col!='docTotal' &&  col!='currentAccountBalance'">
                                <td mat-cell *matCellDef="let element;">
                                    <span style="line-height: 0;">{{element[col]}}</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="col!='Select' && col=='docDate' ">
                                <td mat-cell *matCellDef="let element;">
                                    <span style="line-height: 0;">{{element[col] | date : "dd-MM-yyyy"}}</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="col!='Select' && col=='docTotal'">
                                <td mat-cell *matCellDef="let element;"
                                    style="text-align: right;padding: 0px 30px 0px 0px;">
                                    <span style="line-height: 0;">{{element[col]}}</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="col!='Select' && col=='currentAccountBalance'">
                                <td mat-cell *matCellDef="let element;"
                                    style="text-align: right;padding: 0px 30px 0px 0px;">
                                    <span style="line-height: 0;">{{element[col]}}</span>
                                </td>
                            </ng-container>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
                    </table>

                </div>

            </div>
        </div>

        <!-- </div> -->

    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions">
        <ng-container *ngIf="this.getIsCflSingleSelection">
            <button mat-stroked-button color="warn" [mat-dialog-close]="true" (click)="onClearCFL()">Clear
                Selection</button>
            <button mat-stroked-button color="primary" [mat-dialog-close]="true"
                *ngIf="this.getCFLIsCancel==true">Cancel</button>
            <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onChooseFromCFL()"
                [disabled]="this.isDone==true">Done</button>
        </ng-container>
        <ng-container *ngIf="this.getIsCflSingleSelection==false">
            <button mat-stroked-button color="warn" [mat-dialog-close]="true" (click)="onClearCFL()">Clear
                Selection</button>
            <button mat-stroked-button color="primary" [mat-dialog-close]="true">Cancel</button>
            <button mat-raised-button color="primary" [mat-dialog-close]="true"
                (click)="onChooseFromCFL()">Update</button>
        </ng-container>
    </mat-dialog-actions>
</div>